import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { Cloud, Server, Database } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

const RemoteFileNode = ({ data, selected }: NodeProps) => {
    // Protocol mapping to Icons
    const getIcon = () => {
        switch (data.protocol) {
            case 'S3': return Cloud;
            case 'AzureBlob': return Database;
            case 'SFTP': return Server;
            default: return Cloud;
        }
    };

    const label = data.path ? data.path.split('/').pop() : 'Configure Storage...';
    const subLabel = data?.label || data.protocol || 'Remote File';

    return (
        <BaseNodeUI
            title={subLabel}
            icon={getIcon()}
            colorClass=""
            bgClass="bg-gradient-to-br from-indigo-500 to-indigo-700"
            selected={selected}
            isRunning={data?.executionStatus === 'Running'} executionStatus={data?.executionStatus}
            isTarget={true} // Allow inputs (e.g. from Trigger)
            rowsProcessed={undefined}
        >
            <div className="text-xs truncate" title={data.path}>{label} {data.fileSize ? `(${(data.fileSize / 1024).toFixed(1)} KB)` : ''}</div>
        </BaseNodeUI>
    );
};

export default memo(RemoteFileNode);
